import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { AnnouncementStore, AnnouncementState } from './announcement.store';
import { Observable } from 'rxjs';
import { AnnouncementModel } from './models/announcement.model';

@Injectable({ providedIn: 'root' })
export class AnnouncementQuery extends QueryEntity<AnnouncementState> {
  constructor(protected store: AnnouncementStore) {
    super(store);
  }

  /** All club announcements. */
  announcements(): Observable<AnnouncementModel[]> {
    return this.selectAll();
  }
}
